import React from "react";
import styles from "./PlayButton.module.scss";

interface PlayButtonProps {
  paused: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function PlayButton(props: PlayButtonProps) {
  return (
    <button onClick={props.onClick} className={styles.play}>
      <svg viewBox="0 0 100 100" x="0px" y="0px">
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="rgb(0, 120, 231)"
          stroke="white"
          strokeWidth="5"
        />
        {props.paused ? (
          <path d="M 40 30 l 30 20 l -30 20 Z" fill="#fff" />
        ) : (
          <path
            d="M 43 30 l 0 40 m 15 0 l 0 -40"
            stroke="white"
            strokeWidth="5"
          />
        )}
      </svg>
    </button>
  );
}
